// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3OurO","legacyBtn":"MutateMid_legacyBtn__1kbc9"};